<template>
  <div>
    <Topheader v-if="loginStatus"></Topheader>
    <Headerlogin v-else></Headerlogin>
    <div class="w1100">
      <div class="recommendOne">
        <ul>
          <li v-for="(vo,key) in list" :key="vo.id">
            <!-- 4张图 -->
            <div v-if="vo.imgList.length == 4" class="topImg topImgOne">
              <div class="left">
                <div class="leftImg">
                  <img @click="bigImg(vo.imgList[0].id)" :src="vo.imgList[0].img_url" alt="">
                </div>
              </div>
              <div class="center">
                <div class="imgOne">
                  <img @click="bigImg(vo.imgList[1].id)" :src="vo.imgList[1].img_url" alt="">
                </div>
                <div class="imgOne">
                  <img @click="bigImg(vo.imgList[2].id)" :src="vo.imgList[2].img_url" alt="">
                </div>
              </div>
              <div class="right">
                <img @click="bigImg(vo.imgList[3].id)" :src="vo.imgList[3].img_url" alt="">
              </div>
            </div>
            <!--5张图-->
            <div v-if="vo.imgList.length == 5" class="topImg topImgEigth">
              <div class="left">
                <el-image
                  @click="bigImg(vo.imgList[0].id)"
                  style="width: 458px; height:456px"
                  :src="vo.imgList[0].img_url"
                ></el-image>
              </div>
              <div class="right">
                <el-image
                  @click="bigImg(vo.imgList[1].id)"
                  style="width: 320px; height: 228px"
                  :src="vo.imgList[1].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[2].id)"
                  style="width: 320px; height: 228px"
                  :src="vo.imgList[2].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[3].id)"
                  style="width: 320px; height: 228px"
                  :src="vo.imgList[3].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[4].id)"
                  style="width: 320px; height: 228px"
                  :src="vo.imgList[4].img_url"
                ></el-image>
              </div>
            </div>
            <!--6张图-->
            <div v-if="vo.imgList.length == 6" class="topImg topImgSeven">
              <div class="left">
                <el-image
                  @click="bigImg(vo.imgList[0].id)"
                  style="width: 217px; height: 217px"
                  :src="vo.imgList[0].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[1].id)"
                  style="width: 217px; height: 217px"
                  :src="vo.imgList[1].img_url"
                ></el-image>
              </div>
              <div class="center">
                <el-image
                  @click="bigImg(vo.imgList[2].id)"
                  style="width:330px; height: 434px"
                  :src="vo.imgList[2].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[3].id)"
                  style="width: 330px; height: 434px"
                  :src="vo.imgList[3].img_url"
                ></el-image>
              </div>
              <div class="right">
                <el-image
                  @click="bigImg(vo.imgList[4].id)"
                  style="width: 217px; height: 217px"
                  :src="vo.imgList[4].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[5].id)"
                  style="width: 217px; height: 217px"
                  :src="vo.imgList[5].img_url"
                ></el-image>
              </div>
            </div>
            <!--7张图-->
            <div v-if="vo.imgList.length == 7" class="topImg topImgTwo">
              <div class="left">
                <el-image
                  @click="bigImg(vo.imgList[0].id)"
                  style="width: 217px; height: 217px"
                  :src="vo.imgList[0].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[1].id)"
                  style="width: 217px; height: 217px"
                  :src="vo.imgList[1].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[2].id)"
                  style="width: 217px; height: 217px"
                  :src="vo.imgList[2].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[3].id)"
                  style="width: 217px; height: 217px"
                  :src="vo.imgList[3].img_url"
                ></el-image>
              </div>
              <div class="center">
                <el-image
                  style="width:445px; height: 436px"
                  @click="bigImg(vo.imgList[4].id)"
                  :src="vo.imgList[4].img_url"
                ></el-image>
              </div>
              <div class="right">
                <el-image
                  @click="bigImg(vo.imgList[5].id)"
                  style="width: 217px; height: 217px"
                  :src="vo.imgList[5].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[6].id)"
                  style="width: 217px; height: 217px"
                  :src="vo.imgList[6].img_url"
                ></el-image>
              </div>
            </div>
            <!--8张图-->
            <div v-if="vo.imgList.length == 8" class="topImg topImgSix">
              <div class="left">
                <el-image
                  @click="bigImg(vo.imgList[0].id)"
                  style="width:182px; height: 182px"
                  :src="vo.imgList[0].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[1].id)"
                  style="width: 182px; height: 183px"
                  :src="vo.imgList[1].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[2].id)"
                  style="width: 182px; height: 182px"
                  :src="vo.imgList[2].img_url"
                ></el-image>
                <div class="imgLeft" @click="bigImg(vo.imgList[3].id)">
                  <img :src="vo.imgList[3].img_url" alt="">
                </div>
              </div>
              <div class="right">
                <div class="imgRight" @click="bigImg(vo.imgList[4].id)">
                  <img :src="vo.imgList[4].img_url" alt="">
                </div>
                <el-image
                  @click="bigImg(vo.imgList[5].id)"
                  style="width: 182px; height: 182px"
                  :src="vo.imgList[5].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[6].id)"
                  style="width: 182px; height: 182px"
                  :src="vo.imgList[6].img_url"
                ></el-image>
                <el-image
                  style="width: 182px; height: 182px"
                  @click="bigImg(vo.imgList[7].id)"
                  :src="vo.imgList[7].img_url"
                ></el-image>
              </div>
            </div>
            <!--9张图1-->
            <div v-if="vo.imgList.length == 9" class="topImg topImgThere">
              <div class="left">
                <el-image
                  @click="bigImg(vo.imgList[0].id)"
                  style="width:328px; height: 328px"
                  :src="vo.imgList[0].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[1].id)"
                  style="width: 108px; height: 108px"
                  :src="vo.imgList[1].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[2].id)"
                  style="width: 108px; height: 108px"
                  :src="vo.imgList[2].img_url"
                ></el-image>
                <el-image
                  @click="bigImg(vo.imgList[3].id)"
                  style="width: 110px; height: 108px"
                  :src="vo.imgList[3].img_url"
                ></el-image>
              </div>
              <div class="center">
                <div>
                  <el-image
                    @click="bigImg(vo.imgList[4].id)"
                    style="width: 442px; height: 437px"
                    :src="vo.imgList[4].img_url"
                  ></el-image>
                </div>
              </div>
              <div class="right">
                <div class="top">
                  <el-image
                    @click="bigImg(vo.imgList[5].id)"
                    style="width: 108px; height: 108px"
                    :src="vo.imgList[5].img_url"
                  ></el-image>
                  <el-image
                    @click="bigImg(vo.imgList[6].id)"
                    style="width: 108px; height: 108px"
                    :src="vo.imgList[6].img_url"
                  ></el-image>
                  <el-image
                    @click="bigImg(vo.imgList[7].id)"
                    style="width: 108px; height: 108px"
                    :src="vo.imgList[7].img_url"
                  ></el-image>
                </div>
                <div class="bottom">
                  <el-image
                    style="width: 326px; height: 328px"
                    @click="bigImg(vo.imgList[8].id)"
                    :src="vo.imgList[8].img_url"
                  ></el-image>
                </div>
              </div>
            </div>
            <!--9张图2-->
            <div v-if="vo.imgList.length > 9" class="topImg topImgFour">
              <div class="left">
                <div class="fourLeftTop">
                  <div class="fourImg">
                    <img @click="bigImg(vo.imgList[0].id)" :src="vo.imgList[0].img_url" alt="">
                  </div>
                  <div class="fourImg">
                    <img @click="bigImg(vo.imgList[1].id)" :src="vo.imgList[1].img_url" alt="">
                  </div>
                  <div class="fourImg">
                    <img @click="bigImg(vo.imgList[2].id)" :src="vo.imgList[2].img_url" alt="">
                  </div>
                </div>
                <div class="fourLeftBottom">
                  <img @click="bigImg(vo.imgList[3].id)" :src="vo.imgList[3].img_url" alt="">
                </div>
              </div>
              <div class="center">
                <div class="fourCenter">
                  <img @click="bigImg(vo.imgList[4].id)" :src="vo.imgList[4].img_url" alt="">
                </div>
              </div>
              <div class="right">
                <div class="fourRightTop">
                  <img @click="bigImg(vo.imgList[5].id)" :src="vo.imgList[5].img_url" alt="">
                </div>
                <div class="fourRightBottom">
                  <div class="fourRBImg">
                    <img @click="bigImg(vo.imgList[6].id)" :src="vo.imgList[6].img_url" alt="">
                  </div>
                  <div class="fourRBImg">
                    <img @click="bigImg(vo.imgList[7].id)" :src="vo.imgList[7].img_url" alt="">
                  </div>
                  <div class="fourRBImg">
                    <img @click="bigImg(vo.imgList[8].id)" :src="vo.imgList[8].img_url" alt="">
                  </div>
                </div>
              </div>
            </div>
            <!--公共信息-->
            <div class="wordCont">
              <div class="titAll">
                <div class="left" style="cursor: pointer;" @click="toUserInfo(vo.id)">{{vo.welcome}}</div>
                <div class="right" v-if="!vo.is_self">
                  <div class="iconAll">
                    <div v-if="vo.is_linker" class="icon" @click="onLink(key)">
                      <img src="../../static/icon/linkon.png" alt="">
                    </div>
                    <div v-else class="icon" @click="onLink(key)">
                      <img src="../../static/icon/link.png" alt="">
                    </div>
                    <div
                      class="word"
                      v-if="vo.is_linker"
                      style="margin-right:30px"
                      @click="onLink(key)"
                    >linked</div>
                    <div class="word" v-else style="margin-right:30px" @click="onLink(key)">link</div>
                    <div v-if="vo.is_follow" class="icon" @click="onFollow(key)">
                      <img src="../../static/icon/followon.png" alt="">
                    </div>
                    <div v-else class="icon" @click="onFollow(key)">
                      <img src="../../static/icon/follow.png" alt="">
                    </div>
                    <div class="word" v-if="vo.is_follow" @click="onFollow(key)">following</div>
                    <div class="word" v-else @click="onFollow(key)">follow</div>
                  </div>
                </div>
              </div>
              <!--  -->
              <div class="name">
                <span @click="toUserInfo(vo.id)" style="cursor: pointer;">{{vo.name ? vo.name : '' }}</span>
                · {{vo.swfu}} {{vo.swfu_year}}
              </div>
              <div class="messageAll">
                <div class="left">
                  <div class="message">
                    <div class="icon">
                      <img src="../../static/icon/city.png" alt="">
                    </div>
                    <div class="word">Live in {{vo.area_text}} from {{vo.state_text}}</div>
                  </div>
                  <div class="message">
                    <div class="icon">
                      <img src="../../static/icon/zhiye.png" alt="">
                    </div>
                    <div class="word">
                      <span>Occupation or research field is</span>
                      {{vo.zyly}}
                    </div>
                  </div>
                  <div class="message">
                    <div class="icon">
                      <img src="../../static/icon/chengjiu.png" alt="">
                    </div>
                    <div class="word">
                      <span>成就</span>
                      {{vo.achievement}}
                    </div>
                  </div>
                  <div class="message">
                    <div class="icon">
                      <img src="../../static/icon/web-url.png" alt="">
                    </div>
                    <div class="word">
                      <div class="web_url" @click="common.openUrl(vo.web_url)">
                        <span>{{vo.web_url}}</span>&nbsp; can find me.
                      </div>
                    </div>
                  </div>
                </div>
                <!--  -->
                <div class="right">
                  <img style="cursor: pointer" @click="toUserInfo(vo.id)" :src="vo.head_url" alt="">
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 弹窗 -->
    <div class="bg" v-show="imgBigState" @click="clsoeImgBig()"></div>
    <div class="imgBig" v-show="imgBigState">
      <div class="imgBigAll">
        <div class="imgBigR">
          <!-- <el-image style="width: 616px; height: 616px" :src="showInfo.info.img_url" :fit="cover"></el-image> -->
          <img :src="showInfo.info.img_url" alt="">
        </div>
        <div class="imgBigL">
          <div class="bigName">
            <div class="img">
              <img :src="showInfo.info.head_url" alt="">
            </div>
            <div class="name">{{showInfo.info.user_name}}</div>
          </div>
          <div class="word">{{showInfo.info.content}}</div>
          <div
            class="wordNum"
            @click="toSeeinterflow(showInfo.info.id)"
          >全部{{showInfo.info.leave_num}}条发言</div>
          <div class="talkWord">
            <!-- <div class="scroll-stype">
              <ul>
                <li v-for="item in showInfo.leaveList" :key="item.id">
                  <span class="name">{{item.user_name}}</span>
                  {{item.content}}
                </li>
              </ul>
            </div>-->
            <div class="div1">
              <div class="div2">
                <div class="div3">
                  <ul>
                    <li v-for="item in showInfo.leaveList" :key="item.id">
                      <span class="name">{{item.user_name}}</span>
                      {{item.content}}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="interflowBottom">
            <div class="HightLight">
              <div class="HightLightNum">
                <img
                  v-if="showInfo.info.is_highlight"
                  src="../../static/icon/highlighton.png"
                  alt=""
                  @click="onHighlight(showInfo.info.id)"
                >
                <img
                  v-else
                  src="../../static/icon/highlight.png"
                  alt=""
                  @click="onHighlight(showInfo.info.id)"
                >
                <span>{{showInfo.info.highlight_num}}次Highlight</span>
              </div>
              <div class="time">{{showInfo.info.create_time}}</div>
            </div>
            <div class="interFlow">
              <input
                type="text"
                v-model="content"
                v-on:keyup.enter="subInterflow(showInfo.info.id)"
                placeholder="Interflow…"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Topheader from "../components/header"; //上传图片
  import Headerlogin from "../components/headerLogin"; //

  export default {
    components: {
      Topheader,Headerlogin
    },
    name: "recommend",
    mounted() {
      document
        .querySelector("body")
        .setAttribute("style", "background-color:#CBCBCB");
    },
    created() {
      this.getList();
      this.loginStatus=this.common.isLogin();
    },
    data() {
      return {
        for1: "for1",
        for2: "for2",
        loginStatus:false,
        imgBigState: false, //弹窗
        list: [],
        showInfo: {
          info: {},
          leaveList: []
        },
        content: null
      };
    },
    //方法定义
    methods: {
      toUserInfo(id) {
        this.$router.push({
          path: "/userInfo",
          query: {
            id: id
          }
        });
      },
      toSeeinterflow(id) {
        this.$router.push({
          path: "/seeinterflow",
          query: {
            id: id
          }
        });
      },
      //留言
      subInterflow(id) {
        let _this = this;
          if(!_this.common.isLogin()){
              _this.common.onLoginSure();
              return;
          }
        let data = {
          dynamic_id: id,
          content: _this.content
        };
        _this.common.request(
          "api/dynamicLeave/interflow",
          data,
          function(res) {
            if (res.status == 200) {
              _this.common.vMessage(res.message);
              _this.showInfo.info.leave_num = res.data.leave_num;
              _this.showInfo.leaveList = res.data.leaveList; //更新发言
              _this.content = null;
            }
          },
          "post"
        );
      },
      //显示弹窗
      bigImg(id) {
        let _this = this;
        _this.common.request("api/dynamic/grInfo", { id: id }, function(res) {
          _this.imgBigState = true;
          _this.showInfo = res.data;
          console.log(res);
        });
      },
      //关闭弹窗
      clsoeImgBig() {
        this.imgBigState = false;
      },
      getList() {
        let _this = this;
        _this.common.request("api/user/rmdList", {}, function(res) {
          if (res.status == 200) {
            _this.list = res.data.list;
          }
        });
      },
      //点击高光
      onHighlight(id) {
        let _this = this;
        if(!_this.common.isLogin()){
            _this.common.onLoginSure();
            return;
        }
        _this.common.request(
          "api/dynamic/highlight",
          { id: id },
          function(res) {
            if (res.status == 200) {
              _this.showInfo.info.highlight_num = res.data.highlight_num; //
              _this.showInfo.info.is_highlight = !_this.showInfo.info
                .is_highlight; //
            }
          },
          "post"
        );
      },
      //link操作
      onLink(key) {
        let _this = this;
          if(!_this.common.isLogin()){
              _this.common.onLoginSure();
              return;
          }
        let id = _this.list[key].id;
        _this.common.request(
          "api/userLinker/handel",
          { id: id },
          function(res) {
            if (res.status == 200) {
              _this.list[key].is_linker = !_this.list[key].is_linker;
              _this.common.vMessage(res.message);
            }
          },
          "post"
        );
      },
      //follow操作
      onFollow(key) {
        let _this = this;
          if(!_this.common.isLogin()){
              _this.common.onLoginSure();
              return;
          }
        let id = _this.list[key].id;
        _this.common.request(
          "api/userFollow/handel",
          { id: id },
          function(res) {
            if (res.status == 200) {
              _this.list[key].is_follow = !_this.list[key].is_follow;

              _this.common.vMessage(res.message); //只提示一个
            }
          },
          "post"
        );
      }
    }
  };
</script>

<style scoped lang='less'  rel="stylesheet/less">
  @import "../assets/css/index.less";
  .recommendOne {
    margin-top: 22px;
    ul {
      li {
        margin-bottom: 66px;
        background: #fff;
        .topImgOne {
          .flexStart;
          .left {
            width: 438px;
            // height: 438px;
            .leftImg {
              .imgCover(438px, 438px);
            }
          }
          .center {
            padding-left: 1px;
            display: flex;
            flex-wrap: wrap;
            width: 222px;

            .el-image:first-child {
              padding-bottom: 1px;
              margin-top: -3px;
            }
            .el-image {
              padding-right: 1px;
            }
            .imgOne {
              .imgCover(222px, 219px);
            }
          }
          .right {
            .imgCover(438px, 438px);
            // width: 438px;
            // height: 438px;
          }
        }
        .topImgTwo {
          .flexStart;
          .left {
            display: flex;
            flex-wrap: wrap;
            .el-image {
              padding-right: 1px;
              padding-bottom: 1px;
            }
            .el-image:nth-child(1),
            .el-image:nth-child(2) {
              margin-top: -3px;
            }
          }
          .center {
            .el-image:nth-child(1) {
              margin-left: -2px;
              padding-right: 1px;
            }
          }
          .right {
            display: flex;
            flex-wrap: wrap;
            .el-image:nth-child(1) {
              padding-bottom: 1px;
              margin-top: -4px;
            }
          }
        }
        .topImgThere {
          .flexStart;
          .left {
            padding-left: 1px;
            display: flex;
            flex-wrap: wrap;
            .el-image:first-child {
              padding-bottom: 1px;
              margin-top: -5px;
            }
            .el-image {
              padding-right: 1px;
            }
          }
          .center {
            .el-image {
              padding-right: 1px;
            }
          }
          .right {
            .top {
              .flexStart;
              .el-image {
                padding-right: 1px;
              }
            }
          }
        }

        .topImgFour {
          .flexStart;
          .left {
            display: flex;
            flex-wrap: wrap;
            .fourLeftTop {
              .flexStart;
              .fourImg {
                .imgCover(110px, 108px);
              }
            }
            .fourLeftBottom {
              .imgCover(330px, 334px);
            }
          }
          .center {
            .fourCenter {
              .imgCover(444px, 441px);
            }
          }
          .right {
            display: flex;
            flex-wrap: wrap;
            .fourRightTop {
              .imgCover(326px, 332px);
            }
            .fourRightBottom {
              .flexStart;
              .fourRBImg {
                .imgCover(108.4px, 108px);
              }
            }
          }
        }

        .topImgSix {
          .flexStart;
          .left {
            display: flex;
            flex-wrap: wrap;
            padding-left: 1px;
            .imgLeft {
              .imgNoCut(548px;263px);
            }
            .el-image {
              padding-right: 1px;
            }
          }

          .right {
            display: flex;
            flex-wrap: wrap;
            .imgRight {
              .imgNoCut(548px;263px);
              padding-bottom: 1px;
            }
            .el-image {
              padding-right: 1px;
              padding-top: 1px;
            }
          }
        }

        .topImgSeven {
          .flexStart;
          .left {
            display: flex;
            flex-wrap: wrap;
            .el-image {
              padding-right: 1px;
              padding-bottom: 1px;
            }
          }
          .center {
            display: flex;
            padding-right: 1px;
            .el-image {
              padding-right: 1px;
            }
            .ImgCenter {
              .imgNoCut(330px;436px);
            }
          }
          .right {
            display: flex;
            flex-wrap: wrap;
            .el-image:nth-child(1) {
              padding-bottom: 1px;
              margin-top: -4px;
            }
          }
        }

        .topImgEigth {
          .flexStart;
          .right {
            margin-top: -5px;

            display: flex;
            flex-wrap: wrap;
            padding: 0 1px;
          }
        }
      }
    }
  }

  .wordCont {
    background: #fff;
    padding: 24px;
    .titAll {
      .flexSBetween;
      .left {
        color: #1c1c1c;
        font-size: 24px;
        font-weight: bold;
        width: 80%;
        .oneLines;
      }

      .right {
        .iconAll {
          .flexStart;
          margin-left: 30px;

          .icon {
            width: 18px;
            height: 18px;
            margin-right: 12px;
          }
          .word {
            color: #187eb9;
            font-size: 16px;
          }
        }
      }
    }

    .name {
      color: #7f7f7f;
      font-size: 16px;
      padding: 13px 0 20px 0;
    }

    .messageAll {
      .flexSBetween;
      .left {
        width: calc(100% - 100px);
      }
      .right {
        img {
          width: 100px;
          height: 100px;
          .border-radius(50%);
        }
      }
    }

    .message {
      .flexStart;
      margin-bottom: 16px;
      .icon {
        width: 20px;
        height: 20px;
        margin-right: 22px;
      }
      .word {
        color: #1d1d1d;
        font-size: 14px;
      }
    }
  }

  // 弹窗
  .imgBig {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 1088px;
    z-index: 101;
    margin-left: -544px;
    margin-top: -308px;
    background: #fff;
    .el-carousel__container {
      height: 616px !important;
    }

    .imgBigAll {
      display: flex;
      justify-content: space-between;
      .imgBigR {
        .imgCover(616px, 616px);
        // .imgNoCut(616px, 616px);
      }
      .imgBigL {
        position: relative;
        width: 472px;
        padding: 16px 26px;
        .bigName {
          .flexStart;
          padding-bottom: 16px;
          border-bottom: 1px solid #ebebeb;
          .img {
            margin-right: 15px;
            img {
              width: 44px;
              height: 44px;
              .border-radius(50%);
            }
          }
          .name {
            color: #1d1d1d;
            font-size: 14px;
          }
        }

        .word {
          margin-top: 16px;
          color: #6d6d6d;
          font-size: 14px;
          line-height: 24px;
        }
        .wordNum {
          color: #7f7f7f;
          font-size: 14px;
          margin-top: 14px;
          margin-bottom: 29px;
          cursor: pointer;
        }
        .wordNum:hover {
          text-decoration: underline;
        }
        .talkWord {
          margin-right: -17px;
          // height: 275px;
          height: 240px;
          .div1 {
            width: 474px;
            height: 240px;
            position: relative;
            overflow: hidden;
          }
          .div2 {
            overflow-x: hidden;
            overflow-y: scroll;
            position: absolute;
          }
          .div3 {
            width: 474px;
            height: 240px;
          }

          ul {
            li {
              margin-bottom: 13px;
              font-size: 14px;
              color: #4d4d4d;
              .name {
                color: #4d4d4d;
              }
            }
          }
        }
        .interflowBottom {
          position: absolute;
          bottom: 16px;
          width: calc(100% - 40px);
        }
        .HightLight {
          padding: 16px 0;
          .HightLightNum {
            .flexStart;
            margin-bottom: 20px;
            img {
              width: 18px;
              height: 18px;
              margin-right: 14px;
            }
            span {
              color: #27292a;
              font-size: 14px;
              font-weight: bold;
            }
          }
          .time {
            color: #7f7f7f;
            font-size: 16px;
            font-weight: 400;
          }
        }
        .interFlow {
          border-top: 1px solid #e0e0e0;
          padding-top: 16px;
          input {
            color: #7f7f7f;
            font-size: 18px;
            width: 100%;
          }
        }
      }
    }
  }
  .imgBigTan {
    position: fixed;
    top: 0;
    left: 0;
  }
  .web_url {
    cursor: pointer;
    color: #1d1d1d;
  }

  .web_url span:hover {
    text-decoration: underline;
  }
</style>


// WEBPACK FOOTER //
// src/view/recommend.vue